<template>
    <vx-box
        color="info"
        class="flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500"
    >
        <slot>
            <div class="max-w-132 mx-auto text-center">No results for current search, try adjusting your filters.</div>
            <vx-button type="button" color="secondary" @click="emit('reset')">
                Reset All <font-awesome-icon widthAuto :icon="faCircleX" />
            </vx-button>
        </slot>
    </vx-box>
</template>
<script lang="ts" setup>
import { faCircleX } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton } from '@voxie/frontend-components';

const emit = defineEmits<{
    reset: [];
}>();
</script>
